import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logo from "../assets/img/logo1.png";
import { logout } from "../store/slices/auth";
import WhatsAppButton from "./WhatsAppButton";

const Navbarsticky = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [addBg, setAddBg] = useState("custom-navbar z-3");
  const [expanded, setExpanded] = useState(false);
  const [subMenus, setSubMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mobileSubOpen, setMobileSubOpen] = useState(false);
  const [mobileUserOpen, setMobileUserOpen] = useState(false);

  const { user, isLoggedIn } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    setExpanded(false);
    setMobileUserOpen(false);
  };

  /* ---------------- FETCH CATEGORIES ---------------- */
  useEffect(() => {
    const fetchSubMenus = async () => {
      try {
        const response = await fetch(
          "https://api.andamanmakeholidays.com/api/v1/travelCategory/fetch"
        );
        const result = await response.json();

        if (result.status === 1 && result.categoryData) {
          setSubMenus(
            result.categoryData.filter(
              (item) => item.isActive && !item.isDeleted
            )
          );
        }
      } catch (error) {
        console.error("Error fetching categories", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubMenus();
  }, []);

  /* ---------------- SCROLL BG ---------------- */
  useEffect(() => {
    const handleScroll = () => {
      setAddBg(
        window.scrollY >= 10
          ? "custom-navbar navBar_with_bg z-3"
          : "custom-navbar z-3"
      );
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ---------------- LOCK BODY SCROLL ---------------- */
  useEffect(() => {
    document.body.style.overflow = expanded ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [expanded]);

  return (
    <>
      {/* OVERLAY */}
      {expanded && (
        <div
          className="nav-overlay"
          onClick={() => {
            setExpanded(false);
            setMobileUserOpen(false);
          }}
        />
      )}

      <Navbar
        expand="lg"
        expanded={expanded}
        onToggle={() => {
          setExpanded(!expanded);
          setMobileUserOpen(false);
        }}
        className={`${addBg} ${expanded ? "navbar-expanded" : ""}`}
      >
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img src={logo} alt="logo" className="nav-logo" />
          </Navbar.Brand>

          {/* ---------- MOBILE RIGHT ICONS ---------- */}
          <div className="right-icons d-lg-none position-relative">
            {!isLoggedIn ? (
              <Link to="/login" className="mobile-login-icon">
                <i className="bi bi-person" />
              </Link>
            ) : (
              <div className="mobile-user-dropdown">
                <span
                  className="mobile-username-icon" style={{color:"white", }}
                  onClick={() => setMobileUserOpen(!mobileUserOpen)}
                >
                  <i className="bi bi-person-circle me-1" style={{fontSize:"25px"}} />
                  {/* {user?.data?.name} */}
                  <i className="bi bi-chevron-down ms-1" />
                </span>

                {mobileUserOpen && (
                  <div className="mobile-user-menu">
                    <Link
                      to="/account"
                      onClick={() => {
                        setExpanded(false);
                        setMobileUserOpen(false);
                      }}
                    >
                      My Account
                    </Link>

                    <Link
                      to="/booking-history"
                      onClick={() => {
                        setExpanded(false);
                        setMobileUserOpen(false);
                      }}
                    >
                      My Booking
                    </Link>

                    <button className="logout-btn" onClick={handleLogout}>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            )}

            <Navbar.Toggle className="custom-toggler" />
          </div>

          {/* ---------- DESKTOP MENU ---------- */}
          <Navbar.Collapse className="d-none d-lg-flex">
            <Nav className="mx-auto nav-pages">
              <Nav.Link as={Link} to="/">Home</Nav.Link>

              <NavDropdown title="Tour Package">
                {loading ? (
                  <NavDropdown.Item>Loading...</NavDropdown.Item>
                ) : (
                  subMenus.map((item) => (
                    <NavDropdown.Item
                      key={item._id}  className="dropdown-item-black"
                      as={Link}
                      to={`/tour-packages/${item.slug}`}
                    >
                      {item.categoryName}
                    </NavDropdown.Item>
                  ))
                )}
              </NavDropdown>

              <Nav.Link as={Link} to="/ferry">Ferry Booking</Nav.Link>
              <Nav.Link as={Link} to="/hotels">Hotel</Nav.Link>
              <Nav.Link as={Link} to="/carrental">Car Rental</Nav.Link>
              <Nav.Link as={Link} to="/watersports">Water Sports</Nav.Link>
              <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
            </Nav>

            {!isLoggedIn ? (
              <Link to="/signup" className="login-btn d-none d-lg-block">
                <i className="bi bi-person" /> Signup
              </Link>
            ) : (
              <NavDropdown
                align="end"
                title={
                  <span style={{ color: "white",fontSize:"25px" }}>
                    <i className="bi bi-person-circle me-1" />
                   
                  </span>
                }
              >
                <NavDropdown.Item
  as={Link}
  to="/account"
  className="dropdown-item-black"
>
  My Account
</NavDropdown.Item>

<NavDropdown.Item
  as={Link}
  to="/booking-history"
  className="dropdown-item-black"
>
  My Booking
</NavDropdown.Item>

<NavDropdown.Divider />

<NavDropdown.Item
  onClick={handleLogout}
  className="dropdown-item-black"
>
  Logout
</NavDropdown.Item>

              </NavDropdown>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ---------- MOBILE SLIDE MENU ---------- */}
      <div className={`mobile-slide-menu ${expanded ? "open" : ""}`}>
        <div className="slide-header">
          <img src={logo} alt="logo" className="slide-logo" />
          <i
            className="bi bi-x-lg close-icon"
            onClick={() => setExpanded(false)}
          />
        </div>

        <div className="slide-links">
          <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>
            Home
          </Nav.Link>

          <div
            className="mobile-submenu-title"
            onClick={() => setMobileSubOpen(!mobileSubOpen)}
          >
            <span>Tour Package</span>
            <i
              className={`bi bi-chevron-${
                mobileSubOpen ? "up" : "down"
              } submenu-arrow`}
            />
          </div>

          {mobileSubOpen && (
            <div className="mobile-submenu-items">
              {loading ? (
                <div className="submenu-loading">Loading...</div>
              ) : subMenus.length > 0 ? (
                subMenus.map((item) => (
                  <Link
                    key={item._id}
                    to={`/tour-packages/${item.slug}`}
                    className="submenu-link"
                    onClick={() => {
                      setExpanded(false);
                      setMobileSubOpen(false);
                    }}
                  >
                    {item.categoryName}
                  </Link>
                ))
              ) : (
                <div className="submenu-loading">No Categories Found</div>
              )}
            </div>
          )}

          <Nav.Link as={Link} to="/ferry" onClick={() => setExpanded(false)}>
            Ferry Booking
          </Nav.Link>
          <Nav.Link as={Link} to="/hotels" onClick={() => setExpanded(false)}>
            Hotel
          </Nav.Link>
          <Nav.Link as={Link} to="/carrental" onClick={() => setExpanded(false)}>
            Car Rental
          </Nav.Link>
          <Nav.Link as={Link} to="/watersports" onClick={() => setExpanded(false)}>
            Water Sports
          </Nav.Link>
          <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>
            Contact
          </Nav.Link>
        </div>
      </div>
      <WhatsAppButton />

    </>
  );
};

export default Navbarsticky;
